// Student drop-down shared by the Version 2 student pages (C3.4). The list comes from
// GET /api/v2/admin/students: every student, plus any user with V2 activity (most recent first).
import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { v2Students } from '../../../api/v2admin';

export function useStudents() {
  const q = useQuery({ queryKey: ['v2a', 'students'], queryFn: v2Students });
  return { students: (q.data && q.data.students) || [], loading: q.isLoading };
}

export default function StudentPicker({ value, onChange, allowEmpty, emptyLabel = 'All students', autoPick = false, testId = 'v2-student' }) {
  const { students, loading } = useStudents();
  // Pick the most recently active student when nothing is chosen yet.
  useEffect(() => {
    if (autoPick && !value && students.length) onChange(students[0].id);
  }, [autoPick, value, students, onChange]);
  return (
    <select className="form-input" value={value || ''} data-testid={testId} style={{ maxWidth: 320 }}
      onChange={(e) => onChange(e.target.value)} disabled={loading}>
      {(allowEmpty || !value) && <option value="">{loading ? 'Loading…' : (allowEmpty ? emptyLabel : 'Choose a student')}</option>}
      {students.map((s) => (
        <option key={s.id} value={s.id}>
          {s.name} ({s.username}){s.role !== 'student' ? ` · ${s.role}` : ''}
        </option>
      ))}
    </select>
  );
}
